function RadioInputController () {
  var ctrl = this

  ctrl.$onInit = function () {
    ctrl.$onChanges = ctrl.$onInit
  }
}

export { RadioInputController }
